/**
 * PDP Active Price — dynamic price display.
 * Listens to variant:update (variant switch) and lora-bundle:extra (companion toggle)
 * to render the current variant price + selected companion add-ons.
 *
 * Persists the latest bundle-extra on `window.__loraBundleExtra` so that instances
 * mounted after a checkbox change (e.g. the sticky-bar after a variant morph)
 * pick up the current state on connect.
 */

class PdpActivePrice extends HTMLElement {
  connectedCallback() {
    this._valueEl = this.querySelector('[data-price-current]');
    if (!this._valueEl) return;

    this._basePrice = parseInt(this.dataset.basePrice, 10) || 0;
    this._extra = window.__loraBundleExtra || 0;

    this._onVariantUpdate = this._onVariantUpdate.bind(this);
    this._onBundleExtra = this._onBundleExtra.bind(this);

    document.addEventListener('variant:update', this._onVariantUpdate);
    document.addEventListener('lora-bundle:extra', this._onBundleExtra);

    if (this._extra > 0) this._render();
  }

  disconnectedCallback() {
    document.removeEventListener('variant:update', this._onVariantUpdate);
    document.removeEventListener('lora-bundle:extra', this._onBundleExtra);
  }

  _onVariantUpdate(event) {
    const newPrice = event.detail?.resource?.price;
    if (typeof newPrice !== 'number') return;
    this._basePrice = newPrice;
    this._render();
  }

  _onBundleExtra(event) {
    this._extra = event.detail?.extra || 0;
    this._render();
  }

  _render() {
    const total = this._basePrice + this._extra;
    this._valueEl.textContent = new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
    }).format(total / 100);
    this.classList.toggle('pdp-active-price--bundled', this._extra > 0);
  }
}

if (!customElements.get('pdp-active-price')) {
  customElements.define('pdp-active-price', PdpActivePrice);
}
